import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { auth, database, firebaseConfig } from "../../config/firebase";
import SendMoney from "../accounts/sendMoney";

import Modal from "react-modal";
import {
  getDatabase,
  ref,
  push,
  onValue,
  get,
  child,
  set,
  query,
  orderByChild,
  equalTo,
} from "firebase/database";
import { useAuth } from "../../contexts/AuthContext";
import "./Profile.css";

export default function Profile() {
  localStorage.removeItem("refreshed");
  const navigate = useNavigate();
  const expayAPIUrl = firebaseConfig.expayApiUrl;
    const [name, setName] = useState("");

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedOptionText, setSelectedOptionText] = useState("Select an option");
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showConfirmationModalForPin, setShowConfirmationModalForPIN] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  const [selectedButton, setSelectedButton] = useState(null);
  const [loading, setLoading] = useState(false);
  const [customerNumber, setCustomerNumber] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [rsaKeyIdData, setrsaKeyIdData] = useState("");
  const [rsaPEMData, setrsaPEMData] = useState("");
  const [tcnData, setTcnData] = useState("");
  const [yearOfBirth, setYearOfBirth] = useState("");
  const [newPIN, setnewPIN] = useState("");
  const [pinChangeSuccess, setPinChangeSuccess] = useState("");
  const [lastFourDigits, setLastFourDigits] = useState("");
  const [TL, setTL] = useState(false);
  const { currentUser, updateUserProfile, setError } = useAuth();
  const [manualCardNumber, setManualCardNumber] = useState("");


// Helper function to truncate description
const truncateDescription = (description, maxLength = 50) => {
  if (!description) return "Transaction";
  if (description.length <= maxLength) return description;
  return description.substring(0, maxLength) + "...";
};

    const fetchUserName= async () => {
    try {
      setName("");
      const usersRef = ref(database, `${firebaseConfig.dataPath}${currentUser.uid}`);
      const snapshot = await get(usersRef);
      
      if (snapshot.exists()) {
        const userData = snapshot.val();
        const customerNum = userData.customerNum;
        setCustomerNumber(customerNum);
        setError("");
        setLoading(true);
        
        const token = await currentUser.getIdToken();
        const payloadHeader = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            apiKey: "YOUR_API_KEY",
            payload: customerNum
          }),
        };
        
        const res = await fetch(expayAPIUrl + "/getAccountDetails",payloadHeader)
        const apiResponse = await res.json();
        
         localStorage.setItem("userName", apiResponse.Item.CustomerName);

      setName(apiResponse.Item.CustomerName)
      }
    } catch (e) {
      console.log(e);
      setError("Failed to update profile");
    }
  };
  // PIN Changes
  const updatePIN = async (e) => {
    e.preventDefault();
    setShowConfirmationModalForPIN(true);
  };

  const handleConfirmationForPin = async () => {
    try {
      setPinChangeSuccess("");
      setYearOfBirth("");
      setnewPIN("");
      const usersRef = ref(database, `${firebaseConfig.dataPath}${currentUser.uid}`);
      const snapshot = await get(usersRef);
      
      if (snapshot.exists()) {
        const userData = snapshot.val();
        const customerNum = userData.customerNum;
        setCustomerNumber(customerNum);
        setError("");
        setLoading(true);
        
        const token = await currentUser.getIdToken();
        const payloadHeader = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            apiKey: "YOUR_API_KEY",
            payload: {
              CustomerNumber: customerNum,
              WithSMS: false,
              WithEmail: false,
            },
          }),
        };
        
        const res = await fetch(expayAPIUrl + "/getTransactionPIN", payloadHeader);
        const apiResponse = await res.json();
        setApiResponse(apiResponse);
        setSelectedButton("pinchange");
        setrsaKeyIdData(apiResponse.rsaKey.Item.RsaKeyId);
        setTcnData(apiResponse.tcnNum.Item.TCN);
        setrsaPEMData(apiResponse.rsaKey.Item.PublicKeyInPemFormat);
      }
    } catch (e) {
      console.log(e);
      setError("Failed to update profile");
    }
    setShowConfirmationModalForPIN(false);
    setLoading(false);
  };

  const submitPINForm = async (e) => {
    e.preventDefault();
    try {
      const usersRef = ref(database, `${firebaseConfig.dataPath}${currentUser.uid}`);
      const snapshot = await get(usersRef);
      
      if (snapshot.exists()) {
        const userData = snapshot.val();
        const customerNum = userData.customerNum;
        setError("");
        setLoading(true);
        
        const token = await currentUser.getIdToken();
        const payloadHeader = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            apiKey: "YOUR_API_KEY",
            payload: {
              CustomerNumber: customerNum,
              YOB: yearOfBirth,
              TCN: tcnData,
              LastFourDigits: lastFourDigits,
              EncryptedNewFourDigitPIN: newPIN,
            },
          }),
        };
        
        const res = await fetch(expayAPIUrl + "/changePIN", payloadHeader);
        const apiResponse = await res.json();
        setApiResponse(apiResponse);
        
        if (apiResponse.ErrorDescription === "Successfull") {
          setPinChangeSuccess(true);
        } else {
          setPinChangeSuccess(false);
        }
      }
    } catch (e) {
      console.log(e);
      setError("Failed to update profile");
    }
    setLoading(false);
  };

  const handleCancelConfirmationForPin = () => {
    setShowConfirmationModalForPIN(false);
  };

  // Transaction History
 const transactionHistory = async (e) => {
  e.preventDefault();
  try {
    const usersRef = ref(database, `${firebaseConfig.dataPath}${currentUser.uid}`);
    const snapshot = await get(usersRef);
    
    if (snapshot.exists()) {
      const userData = snapshot.val();
      const customerNum = userData.customerNum;
      
      setCustomerNumber(customerNum);
      setError("");
      setLoading(true);
      
      const token = await currentUser.getIdToken();
      
      // NEW: Single API call that handles everything
      const res = await fetch(expayAPIUrl + "/getCustomerTransactions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          apiKey: "YOUR_API_KEY",
          customerNumber: customerNum,  // Only need customerNumber now
        }),
      });
      
      const response = await res.json();
      
      if (response.success && response.transactions?.Item) {
        setApiResponse({ transactions: response.transactions.Item });
        setSelectedButton("showData");
      } else {
        setError("No transactions found");
      }
    }
  } catch (e) {
    console.log(e);
    setError("Failed to fetch transactions");
  }
  setLoading(false);
};



  // Card Activation
  const cardActivation = async (e) => {
    e.preventDefault();
    setShowConfirmationModal(true);
  };

  const handleDisableConfirmation = async () => {
    try {
      const usersRef = ref(database, `${firebaseConfig.dataPath}${currentUser.uid}`);
      const snapshot = await get(usersRef);
      
      if (snapshot.exists()) {
        const userData = snapshot.val();
        const customerNum = userData.customerNum;
        setError("");
        setLoading(true);
        
        const token = await currentUser.getIdToken();
        const res = await fetch(expayAPIUrl + "/disableCard", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            apiKey: "YOUR_API_KEY",
            payload: { CustomerNumber: customerNum },
          }),
        });
        
        const apiResponse = await res.json();
        setApiResponse({ ...apiResponse, action: "frozen" });
        setSelectedButton("cardActivation");
        setShowConfirmationModal(false);
      }
    } catch (e) {
      console.log(e);
      setError("Failed to freeze card");
    }
    setLoading(false);
  };

  const handleConfirmation = async () => {
    try {

      if (!manualCardNumber || manualCardNumber.length !== 4) {
  alert("Please enter the last 4 digits of your card");
  return;
}

      const usersRef = ref(database, `${firebaseConfig.dataPath}${currentUser.uid}`);
      const snapshot = await get(usersRef);
      
      if (snapshot.exists()) {
        const userData = snapshot.val();
        const customerNum = userData.customerNum;
        const cardNum = manualCardNumber;
        const lastFourDigits = manualCardNumber;

        setError("");
        setLoading(true);
        
        const token = await currentUser.getIdToken();
        const res = await fetch(expayAPIUrl + "/CardActivation", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            apiKey: "YOUR_API_KEY",
            payload: {
              CustomerNumber: customerNum,
              CardNumber: cardNum,
              BeginDate: "2019-01-19",
              LastFourDigits: lastFourDigits,
            },
          }),
        });
        
        const apiResponse = await res.json();
        setApiResponse({ ...apiResponse, action: "activated" });
        setSelectedButton("cardActivation");
          setManualCardNumber("");

        setShowConfirmationModal(false);
      }
    } catch (e) {
      console.log(e);
      setError("Failed to activate card");
    }
    setLoading(false);
  };

  const handleButtonClick = (buttonId) => {
    const button = document.getElementById(buttonId);
    if (button) button.click();
    
    const buttonTexts = {
      transactionButton: "Transaction History",
      cardButton: "Activate/Freeze Card",
      updatePINButton: "Update PIN",
    };
    
    setSelectedOptionText(buttonTexts[buttonId] || "Select an Option");
    setDropdownOpen(false);
  };

  const handleCancelConfirmation = () => {
      setManualCardNumber("");

    setShowConfirmationModal(false);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  
  useEffect(() => {
    // check if already in localStorage
    const storedName = localStorage.getItem("userName");
    if (storedName) {
      setName(storedName);
    } else {
      fetchUserName();
    }
  }, []);

  const handleLogout = () => {
    // clear localStorage on logout
    localStorage.removeItem("userName");
    setName("");
    // add your logout logic here (auth signOut, redirect, etc.)
  };
  
  return (
    <div className="profile-beautified-container">
      <div className="profile-beautified-wrapper">
        {/* Header */}
        <div className="profile-beautified-header">
          <br /><br /><br /><br />
          <h1>Welcome, {name || "..."}</h1>

</div>
        {/* Action Buttons - Desktop */}
        <div className="action-buttons-desktop">
          <button
  id="sendMoneyButton"
  className={`action-card ${selectedButton === "sendMoney" ? "active" : ""}`}
  type="button"
  onClick={() => {
    setSelectedButton("sendMoney");
    setTL(true);
  }}
>
  <div className="action-icon">💸</div>
  <div className="action-content">
    <h3>Send Money</h3>
    <p>Transfer funds to another account</p>
  </div>
</button>
          <form onSubmit={transactionHistory}>
            <button
              id="transactionButton"
              className={`action-card ${selectedButton === "showData" ? "active" : ""}`}
              type="submit"
              onClick={() => setTL(true)}
            >
              <div className="action-icon">📊</div>
              <div className="action-content">
                <h3>Transaction History</h3>
                <p>View your recent transactions</p>
              </div>
            </button>
          </form>

          <form onSubmit={cardActivation}>
            <button
              id="cardButton"
              className={`action-card ${selectedButton === "cardActivation" ? "active" : ""}`}
              type="submit"
              onClick={() => setTL(true)}
            >
              <div className="action-icon">💳</div>
              <div className="action-content">
                <h3>Manage Card</h3>
                <p>Activate or freeze your card</p>
              </div>
            </button>
          </form>

          <form onSubmit={updatePIN}>
            <button
              id="updatePINButton"
              className={`action-card ${selectedButton === "pinchange" ? "active" : ""}`}
              type="submit"
              onClick={() => setTL(true)}
            >
              <div className="action-icon">🔐</div>
              <div className="action-content">
                <h3>Update PIN</h3>
                <p>Change your card PIN here </p>
              </div>
            </button>
          </form>

          

        </div>



        {/* Mobile Dropdown */}
        <div className="action-buttons-mobile">
          <button className="mobile-dropdown-btn" onClick={toggleDropdown}>
            <span>{selectedOptionText}</span>
            <svg className={`dropdown-arrow ${dropdownOpen ? "open" : ""}`} viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <polyline points="6 9 12 15 18 9" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
          
          {dropdownOpen && (

            
            <div className="mobile-dropdown-menu">
                <button onClick={() => handleButtonClick("sendMoneyButton")}>
                <span>💸</span>
                Send Money
              </button>
              <button onClick={() => handleButtonClick("transactionButton")}>
                <span>📊</span>
                Transaction History
              </button>
           

              <button onClick={() => handleButtonClick("cardButton")}>
                <span>💳</span>
                Activate/Freeze Card
              </button>
              <button onClick={() => handleButtonClick("updatePINButton")}>
                <span>🔐</span>
                Update PIN
              </button>
            </div>
          )}
        </div>

        {/* Content Area */}
        <div className="content-display-area">
          {!TL ? (
            <div className="empty-state-profile">
              <svg className="empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="12" cy="12" r="10" strokeWidth="2"/>
                <line x1="12" y1="8" x2="12" y2="12" strokeWidth="2" strokeLinecap="round"/>
                <line x1="12" y1="16" x2="12.01" y2="16" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              <h3>Get Started</h3>
              <p>Select an option above to manage your account</p>
            </div>
          ) : (
            <>
    
  {selectedButton === "showData" && apiResponse?.transactions && (
  <div className="transactions-display">
    {(() => {
      const transactions = apiResponse.transactions;
      
      // Group transactions by date
      const groupedTransactions = {};
      
      transactions.forEach((transaction) => {
        const transactionDate = new Date(transaction.TransactionDate);
        const dateKey = transactionDate.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
        
        if (!groupedTransactions[dateKey]) {
          groupedTransactions[dateKey] = [];
        }
        groupedTransactions[dateKey].push(transaction);
      });
      
      // Sort dates in descending order (newest first)
      const sortedDates = Object.keys(groupedTransactions).sort(
        (a, b) => new Date(b) - new Date(a)
      );
      
      return sortedDates.map((date) => (
        <div className="transaction-date-group" key={date}>
          <h3 className="transaction-date">{date}</h3>
          <div className="transactions-list">
            {groupedTransactions[date].map((transaction, index) => (
              <div className="transaction-card" key={`transaction-${transaction.Id}-${index}`}>
                <div className="transaction-card-header">
                  <div className="merchant-section">
                    <div className="merchant-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <circle cx="12" cy="12" r="10" strokeWidth="2"/>
                        <path d="M12 6v6l4 2" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </div>
                    <div>
<h4>{transaction.Description && transaction.Description.length <= 50 ? transaction.Description : "Transaction"}</h4>                      {transaction.ChannelType === "ETRANSFER" && transaction.DestinationAccountName && (
                        <p style={{ fontSize: '0.8rem', color: '#6b7280', margin: '0.25rem 0' }}>
                          To: {transaction.DestinationAccountName}
                        </p>
                      )}
                      <span className="transaction-badge">
                        {transaction.TransactionType}
                      </span>
                      <span className="transaction-status" style={{
                        marginLeft: '0.5rem',
                        fontSize: '0.7rem',
                        padding: '0.2rem 0.5rem',
                        borderRadius: '4px',
                        background: transaction.TransactionStatusDesc === 'Completed' || transaction.TransactionStatusDesc === 'Settled' 
                          ? '#10b981' 
                          : transaction.TransactionStatusDesc === 'Cancelled' || transaction.TransactionStatusDesc === 'Rejected'
                          ? '#ef4444'
                          : '#f59e0b',
                        color: 'white'
                      }}>
                        {transaction.TransactionStatusDesc}
                      </span>
                    </div>
                  </div>
                  <div className={`transaction-main-amount ${transaction.Amount < 0 ? "debit" : "credit"}`}>
                    {transaction.AmountDisplay}
                  </div>
                </div>
                <div className="transaction-card-footer">
                  {transaction.FeeAmount > 0 && (
                    <div className="transaction-detail">
                      <span>Fee</span>
                      <span>-${transaction.FeeAmount}</span>
                    </div>
                  )}
                  <div className="transaction-detail">
                    <span>Balance</span>
                    <span className="balance">${transaction.RemainingBalance}</span>
                  </div>
                  <div className="transaction-detail">
                    <span>Channel</span>
                    <span>{transaction.ChannelType}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ));
    })()}
  </div>
)}

              {/* Send Money */}
{selectedButton === "sendMoney" && (
  <div className="send-money-section">
    <SendMoney />
  </div>
)}


              {/* PIN Change Form */}
              {selectedButton === "pinchange" && (
                <div className="pin-change-container">
                  {pinChangeSuccess === true ? (
                    <div className="success-result">
                      <div className="result-icon success">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" strokeWidth="2" strokeLinecap="round"/>
                          <polyline points="22 4 12 14.01 9 11.01" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                      </div>
                      <h3>Success!</h3>
                      <p>Your PIN has been activated successfully</p>
                    </div>
                  ) : (
                    <>
                      {pinChangeSuccess === false && (
                        <div className="error-alert">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <circle cx="12" cy="12" r="10" strokeWidth="2"/>
                            <line x1="15" y1="9" x2="9" y2="15" strokeWidth="2" strokeLinecap="round"/>
                            <line x1="9" y1="9" x2="15" y2="15" strokeWidth="2" strokeLinecap="round"/>
                          </svg>
                          <p>PIN activation failed. Please try again!</p>
                        </div>
                      )}
                      {pinChangeSuccess === "" && (
                        <div className="info-alert">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <circle cx="12" cy="12" r="10" strokeWidth="2"/>
                            <line x1="12" y1="16" x2="12" y2="12" strokeWidth="2" strokeLinecap="round"/>
                            <line x1="12" y1="8" x2="12.01" y2="8" strokeWidth="2" strokeLinecap="round"/>
                          </svg>
                          <p>This link will be valid for 10 minutes</p>
                        </div>
                      )}
                      <form className="pin-form" onSubmit={submitPINForm}>
                        <div className="form-field">
                          <label>Year of Birth</label>
                          <input
                            type="text"
                            value={yearOfBirth}
                            onChange={(e) => setYearOfBirth(e.target.value)}
                            placeholder="YYYY"
                            required
                          />
                        </div>
                        <div className="form-field">
                          <label>Last 4 Digits of Card</label>
                          <input
                            type="text"
                            value={lastFourDigits}
                            onChange={(e) => setLastFourDigits(e.target.value)}
                            placeholder="••••"
                            maxLength="4"
                            required
                          />
                        </div>
                        <div className="form-field">
                          <label>New PIN</label>
                          <input
                            type="password"
                            value={newPIN}
                            onChange={(e) => setnewPIN(e.target.value)}
                            placeholder="••••"
                            pattern="[0-9]{4}"
                            maxLength="4"
                            required
                          />
                          <small>Please enter 4 numeric characters</small>
                        </div>
                        <button type="submit" className="submit-button" disabled={loading}>
                          {loading ? "Processing..." : "Change PIN"}
                        </button>
                      </form>
                    </>
                  )}
                </div>
              )}

              {/* Card Activation Status */}
              {selectedButton === "cardActivation" && apiResponse && (
                <div className="status-display">
                  <div className="status-icon-wrapper">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <rect x="1" y="4" width="22" height="16" rx="2" strokeWidth="2"/>
                      <line x1="1" y1="10" x2="23" y2="10" strokeWidth="2"/>
                    </svg>
                  </div>
                  <p>
                    {(() => {
                      const errorCode = apiResponse?.ErrorCode || apiResponse?.apiResponse?.ErrorCode;
                      const action = apiResponse?.action || apiResponse?.apiResponse?.action || "updated";
                      
                      if (errorCode === "0") {
                        return `Your card is successfully ${action}.`;
                      } else if (errorCode === "UpdCardStatusE4") {
                        return `Card is already ${action}.`;
                      } else {
                        return "We were unable to update your card status. Please contact support.";
                      }
                    })()}
                  </p>
                </div>
              )}
            </>
          )}
        </div>

        {/* Card Management Modal */}
        <Modal
          isOpen={showConfirmationModal}
          onRequestClose={handleCancelConfirmation}
          className="beautified-modal"
          overlayClassName="beautified-modal-overlay"
        >
          <div className="beautified-modal-content">
            <button className="modal-close-btn" onClick={handleCancelConfirmation}>×</button>
            <h3>Manage Your Card</h3>
            <p>Select an action to manage your card</p>
                {/* ✅ ADD INPUT HERE */}
    <div className="form-field" style={{ marginTop: "1rem" }}>
      <label>Last 4 digits of your card</label>
      <input
        type="text"
        value={manualCardNumber}
        onChange={(e) => setManualCardNumber(e.target.value)}
        placeholder="••••"
        maxLength={4}
        pattern="[0-9]{4}"
        inputMode="numeric"
        required
      />
    </div>
            <div className="modal-action-buttons">
              <button className="modal-action-btn unfreeze" onClick={handleConfirmation}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <rect x="3" y="11" width="18" height="11" rx="2" strokeWidth="2"/>
                  <path d="M7 11V7a5 5 0 0 1 9.9-1" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                Unfreeze Card
              </button>
              <button className="modal-action-btn freeze" onClick={handleDisableConfirmation}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <rect x="3" y="11" width="18" height="11" rx="2" strokeWidth="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                Freeze Card
              </button>
              <button className="modal-action-btn activate" onClick={handleConfirmation}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" strokeWidth="2" strokeLinecap="round"/>
                  <polyline points="22 4 12 14.01 9 11.01" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                Activate New Card
              </button>
            </div>
          </div>
        </Modal>

        {/* PIN Change Confirmation Modal */}
        <Modal
          isOpen={showConfirmationModalForPin}
          onRequestClose={handleCancelConfirmationForPin}
          className="beautified-modal"
          overlayClassName="beautified-modal-overlay"
        >
          <div className="beautified-modal-content">
            <h3>Change PIN Confirmation</h3>
            <p>Do you want to change your PIN?</p>
            <p className="modal-warning">Note: This link will remain active for 10 minutes only.</p>
            <div className="modal-buttons-horizontal">
              <button className="modal-btn secondary" onClick={handleCancelConfirmationForPin}>
                No
              </button>
              <button className="modal-btn primary" onClick={handleConfirmationForPin}>
                Yes
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
}